<fr8bot-ui-input-field
  [(value)]="value"
  [touched]="touched()"
  [dirty]="dirty()"
  [errors]="errors()"
  [disabled]="disabled()"
  [required]="required()"
  [isErrorVisible]="isErrorVisible()"
  [label]="label()"
  [placeholder]="placeholder()"
  [size]="size()"
  [type]="inputType()"
  [inputName]="inputName()"
  [autocomplete]="autocomplete()"
  [isFocused]="isFocused()"
  (touch)="touch.emit()"
>
  <span postfix class="tw:flex tw:h-full">
    <button
      uiFieldAction
      [disabled]="disabled()"
      [attr.aria-label]="
        (inputType() === 'password'
          ? 'common.passwordField.showPassword'
          : 'common.passwordField.hidePassword'
        ) | translate
      "
      (click)="toggleType()"
    >
      <fr8bot-ui-icon
        [name]="inputType() === 'password' ? 'visible-yes-16' : 'visible-no-16'"
        [size]="16"
      />
    </button>
  </span>
</fr8bot-ui-input-field>
